const allowEmailNotificationsReducer = (allowEmailNotifications = false, action) => {
    switch (action.type) {
        case "ADD_ALLOW_EMAIL_NOTIFICATIONS":
            return action.payload;
        default:
            return allowEmailNotifications;
    }
};

export default allowEmailNotificationsReducer;